import FiscaliteScreen, { fmt } from './FiscaliteScreen';
import axiosInstance from '../../../variables/api/axiosInstance';
import { frenchDate } from '../../../variables/functions';

// Retenues sur honoraires à reverser : paiements d'experts d'un mois, avec la retenue en exergue
// + récap par expert (nom, montant retenu).
const num = (n) => Number(n) || 0;

const RetenuesHonoraires = () => {
    const fetchRows = (start, end, compagnie) =>
        axiosInstance.get('/api/decaissement/all-honoraires-payes', { params: { startDate: start, endDate: end, compagnie: compagnie || undefined } })
            .then((r) => r.data || []);

    const dateOf = (r) => r.dateReglement || r.dateSaisie;

    const columns = [
        { title: 'Expert', dataIndex: 'beneficiaire', render: (v) => v || '—' },
        { title: 'Libellé', dataIndex: 'motifReglement', render: (v) => v || '—' },
        { title: 'N° Sinistre', key: 'sin', render: (_, r) => r.numeroSinistreM || r.numeroSinistreP || '—' },
        { title: 'Date', key: 'date', render: (_, r) => (dateOf(r) ? frenchDate(dateOf(r)) : '—') },
        { title: 'Montant payé (FCFA)', dataIndex: 'montantPaye', align: 'right', render: (v) => fmt(v) },
        {
            title: 'Retenue (FCFA)', dataIndex: 'retenue', align: 'right',
            render: (v) => <b style={{ color: '#242166', fontVariantNumeric: 'tabular-nums' }}>{fmt(v)}</b>,
            sorter: (a, b) => num(a.retenue) - num(b.retenue),
        },
    ];

    const kpis = (rows) => [
        { label: 'Paiements experts', value: rows.length },
        { label: 'Honoraires payés', value: rows.reduce((a, r) => a + num(r.montantPaye), 0), money: true },
        { label: 'Retenues à reverser', value: rows.reduce((a, r) => a + num(r.retenue), 0), money: true, highlight: true, sub: 'à reverser à l\'État' },
    ];

    // Récap par expert (bénéficiaire).
    const recapParExpert = (rows) => {
        const map = new Map();
        rows.forEach((r) => {
            const key = r.beneficiaire || '—';
            const g = map.get(key) || { label: key, count: 0, total: 0 };
            g.count += 1;
            g.total += num(r.retenue);
            map.set(key, g);
        });
        return Array.from(map.values()).sort((a, b) => b.total - a.total);
    };

    // Taux d'impôt (retenue) dérivé : retenue = base × taux/100 (montantPaye = base HT côté PG) → taux exact.
    const tauxOf = (r) => (num(r.montantPaye) > 0 ? Math.round((num(r.retenue) / num(r.montantPaye)) * 1000) / 10 : 0);
    const recapParTaux = (rows) => {
        const map = new Map();
        rows.forEach((r) => {
            const key = `${tauxOf(r)}%`;
            const g = map.get(key) || { label: key, count: 0, total: 0 };
            g.count += 1;
            g.total += num(r.retenue);
            map.set(key, g);
        });
        return Array.from(map.values()).sort((a, b) => b.total - a.total);
    };

    const groupRecaps = [
        { title: 'Récapitulatif par taux d\'impôt', labelHeader: 'Taux d\'impôt', compute: recapParTaux },
        { title: 'Récapitulatif par expert', labelHeader: 'Expert', compute: recapParExpert },
    ];

    const exportColumns = [
        { header: 'Expert', accessor: (r) => r.beneficiaire || '' },
        { header: 'Libellé', accessor: (r) => r.motifReglement || '' },
        { header: 'N° Sinistre', accessor: (r) => r.numeroSinistreM || r.numeroSinistreP || '' },
        { header: 'Date', accessor: (r) => (dateOf(r) ? frenchDate(dateOf(r)) : '') },
        { header: 'Montant payé (FCFA)', accessor: (r) => num(r.montantPaye), money: true },
        { header: 'Retenue (FCFA)', accessor: (r) => num(r.retenue), money: true },
    ];

    return (
        <FiscaliteScreen
            title="Retenues sur honoraires à reverser"
            subtitle="Retenues fiscales sur les honoraires d'experts payés dans le mois"
            fetchRows={fetchRows}
            kpis={kpis}
            columns={columns}
            exportColumns={exportColumns}
            groupRecaps={groupRecaps}
            pdfTitle="RETENUES SUR HONORAIRES À REVERSER"
            fileBase="Retenues_honoraires"
        />
    );
};

export default RetenuesHonoraires;
